export default __webpack_public_path__ + "static/planet1-xs-31ffabefc8ca64d7724c47c191a8059e.webp";